import React from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import themeColors from 'src/theme/colors';
import { useTranslation } from 'react-i18next';
import { pdfDateLocale } from 'src/utils/pdfDateLocale';

const styles = StyleSheet.create({
  position: {
    fontFamily: 'Poppins',
    colors: themeColors.ghgDarkGrey,
    position: 'absolute',
    left: '100px',
    top: '434px',
    width: '200px',
    textAlign: 'center',
  },
  label: {
    fontSize: '12px',
  },
});

export default function CreationDate() {
  const { t, i18n } = useTranslation(undefined, { keyPrefix: 'ghg' });
  return (
    <View style={styles.position}>
      <Text>
        {new Intl.DateTimeFormat(pdfDateLocale(i18n.language, 'pl-PL')).format(
          new Date()
        )}
      </Text>
      <Text style={styles.label}>{t('certificate.issuedDate')}</Text>
    </View>
  );
}
